import { render, staticRenderFns } from "./addPrice.vue?vue&type=template&id=acfb5b6e&scoped=true"
import script from "./addPrice.vue?vue&type=script&lang=js"
export * from "./addPrice.vue?vue&type=script&lang=js"
import style0 from "./addPrice.vue?vue&type=style&index=0&id=acfb5b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfb5b6e",
  null
  
)

export default component.exports